// Add this at the top of your file
import { useState, useEffect } from 'react';

const useImageLoader = (imageUrl: string | undefined) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!imageUrl) {
      setError(true);
      return;
    }

    const img = new Image();
    img.src = imageUrl;
    
    img.onload = () => {
      setIsLoaded(true);
      setError(false);
    };
    
    img.onerror = () => {
      setIsLoaded(true); 
      setError(true);
    };

    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [imageUrl]);

  return { isLoaded, error };
};

export default useImageLoader;